import { GameController } from "../../../../../controllers/GameController";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { TutorialMole } from "../TutorialMole";
import { IMoleState } from "./IMoleState";

export class TutorialDieState implements IMoleState {
    private nextState: IMoleState;

    public constructor(
        private readonly mole: TutorialMole,
        private readonly animationController: MoleAnimationController,
        private readonly gameController: GameController
    ) {
        this.nextState = this;
    }

    public enter(_previousState: IMoleState): void {
        this.gameController.completeTutorial();
        this.mole.cancelArrowAnimation();
        this.mole.cancelTextAnimation();
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        this.animationController.transitToState(MoleAnimationState.Death);
    }

    private handleClipEnd(_state: MoleAnimationState): void {
        this.nextState = null;
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
    }

    public process(_dt: number): IMoleState {
        return this.nextState;
    }

}